import styled from 'styled-components';
import breakpoint from 'Styles/breakpoints';
import { fontTitle, fontBody } from 'Styles/fonts';
import { white, bombasGreen } from 'Styles/colors';

import Icon from '../Icons/Icon';
import BaseButton from '../Button/Button';

export const FooterEmailSuccess = styled.div`
  text-align: center;
`;

export const HeadingSmall = styled.h1`
  margin: 0;
  color: ${white};
  ${fontTitle(24)}
  margin-bottom: 8px;
`;

export const BodyCopySuccess = styled.p`
  ${fontBody(14)};
  color: ${white};
  margin: 0;
`;

export const ButtonOutline = styled(BaseButton)`
  color: ${bombasGreen};
  border: 2px solid ${bombasGreen};
  background: ${white};
  line-height: 0;
  margin: 8px 0;
  align-self: center;

  ${breakpoint('large')} {
    margin-bottom: 24px;
  }
`;

export const CheckIcon = styled(Icon).attrs({ name: 'check' })`
  margin-right: 8px;
  font-size: 20px;
`;

export const ButtonTextWrap = styled.div`
  display: flex;
`;

export const HiddenField = styled.input`
  position: fixed;
  top: 0;
  clip: rect(0, 0, 0, 0);
`;
